import React from "react";
import { FaServer } from "react-icons/fa";
import {
  accessGov,
  architecture,
  ciso,
  configuration,
  home,
  IT,
  RAMP,
  Regulatory,

  SirarNavIcon,
} from "../assets/images/index";

const createLazyComponent = (importFn, exportName) => {
  return React.lazy(async () => {
    const module = await importFn();
    return { default: module[exportName] };
  });
};

// ==================== AUTH MODULES ====================
const SignIn = React.lazy(() => import("../app/auth/SignIn.js"));
const LicenseBackend = React.lazy(() =>
  import("../app/auth/LicenseBackend.js")
);
const ConfigurationPage = React.lazy(() =>
  import("../app/auth/ConfigurationPage.js")
);

// ==================== HOME MODULES ====================
const HomePage = React.lazy(() => import("../Modules/Home/HomePageLanding.js"));
const UserAccessReview = React.lazy(() =>
  import("../Modules/Home/ApplicationUserAccessReview/userReviewLanding.js")
);

// ==================== GOVERNANCE AND COMPLIANCE MODULES ====================
const LicenseManagement = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/LicenseManagement/LincenseLanding"
  )
);
const GNCLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/Compliance/Summary/GNCLanding.jsx"
  )
);

// Compliance Submodules
const Vulnerabilites = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/Compliance/Vulnerabilites/VulnerabilitesLanding.js"
  )
);
const CISBenchmarkCompliance = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/Compliance/CISBenchmarkCompliance/CISBenchmarkComplianceLanding"
  )
);
const SecurityHubFindings = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/Compliance/securityHub/securityHubFindingsLandings"
  )
);
const SBOMLanding = React.lazy(() =>
  import("../Modules/governance-and-compliance/Compliance/SBOM/SBOMLanding.js")
);
const AssetCoverageLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/Compliance/AssetsCoverage/pages/AssetCoverageLanding.js"
  )
);

// Regulatory Compliance Submodules
const TRMGLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/RegulatoryCompliance/TRMG/TRMGLanding.js"
  )
);
const RMiTLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/RegulatoryCompliance/RMiT/RMiTLanding.js"
  )
);
const ManagementC09Complaince = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/RegulatoryCompliance/circular9/ManageC09Complaince/index.jsx"
  )
);
const ManagementIM8Compliance = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/RegulatoryCompliance/IMI8/ManageIM8Compliance/index.jsx"
  )
);

const BSPComplianceLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/RegulatoryCompliance/BSPCompliance/BSPComplianceLanding.jsx"
  )
);

const RegulatoryComplianceLayout = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/RegulatoryCompliance/RegulatoryComplianceLayout.js"
  )
);

// CISO Dashboard Submodules
const CisoDBoardManagement = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/cisoDashboard/CisoLandingPage.js"
  )
);
const CisoC09DBoardManagement = React.lazy(() =>
  import("../Modules/governance-and-compliance/cisoDashboard/CisoLandingPage.js")
);
const CisoIMI8DBoardManagement = React.lazy(() =>
  import("../Modules/governance-and-compliance/cisoDashboard/ManageCisoIMI8.js")
);
const CisoSHFLanding = React.lazy(() =>
  import("../Modules/governance-and-compliance/cisoDashboard/CisoSHFLanding.js")
);
const CisoTRMGLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/cisoDashboard/CisoTRMGLanding.js"
  )
);
const CisoRMITLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/cisoDashboard/CisoRMITLanding.js"
  )
);
const CisoBSPLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/cisoDashboard/CisoBSPCompliance.js"
  )
);
const CisoLandingCIS = React.lazy(() =>
  import("../Modules/governance-and-compliance/cisoDashboard/CisoLandingCIS.js")
);

const CISOSBOMLanding = React.lazy(() =>
  import(
    "../Modules/governance-and-compliance/cisoDashboard/CISOSBOMLanding.js"
  )
);

// ==================== CLOUD INSIGHTS MODULES ====================
const CloudCostInsights = React.lazy(() =>
  import("../Modules/CloudInsights/CloudCostInsights/pages/Landing.js")
);
const CostOverview = React.lazy(() =>
  import("../Modules/CloudInsights/CloudCostInsights/pages/CostOverView.js")
);
const ResilenceLanding = React.lazy(() =>
  import("../Modules/CloudInsights/Resilency/ResilenceLanding.jsx")
);

// Architecture Compliance Submodules
const ArchitectureLanding = React.lazy(() =>
  import(
    "../Modules/CloudInsights/ArchitectureCompliance/Compliance/pages/ArchitectureComplianceLanding.js"
  )
);
const ArchitectureDiagramLanding = React.lazy(() =>
  import(
    "../Modules/CloudInsights/ArchitectureCompliance/CreateDiagram/pages/DiagramLanding.js"
  )
);
const ConfigurationFilter = React.lazy(() =>
  import(
    "../Modules/CloudInsights/ArchitectureCompliance/Compliance/pages/ConfigurationFilter.jsx"
  )
);

// Cloud Access Governance Submodules
const UserReview = React.lazy(() =>
  import(
    "../Modules/CloudInsights/CloudAccessGovernance/AccessReview/pages/UserReviewLanding.js"
  )
);
const UserGraph = React.lazy(() =>
  import(
    "../Modules/CloudInsights/CloudAccessGovernance/UserGraphs/UserGraphLanding.js"
  )
);
const SummaryPDF = React.lazy(() =>
  import(
    "../Modules/CloudInsights/CloudAccessGovernance/AccessReview/SummaryPDF/UserPdf/UserPdfLanding.js"
  )
);


// ==================== CONFIGURATION MODULES ====================
const Tools = createLazyComponent(() => import("common-components"), "Tools");
// const Tools = React.lazy(() =>
//   import("../Modules/configuration/admin/tools/Tools.js")
// );
const ToolDynamicRouter = createLazyComponent(() => import("common-components"), "ToolDynamicRouter");

const AuditLog = createLazyComponent(
  () => import("common-components"),
  "AuditLog"
);

// CMDB Submodules
const AppConfig = createLazyComponent(
  () => import("common-components"),
  "AppConfig"
);
const Business = createLazyComponent(
  () => import("common-components"),
  "Business"
);
const RoleAllocation = createLazyComponent(
  () => import("common-components"),
  "RoleAllocation"
);
const User = createLazyComponent(() => import("common-components"), "User");
const DevicesConfig = createLazyComponent(
  () => import("common-components"),
  "DevicesConfig"
);
const Projects = createLazyComponent(
  () => import("common-components"),
  "Projects"
);
const CloudAccount = createLazyComponent(
  () => import("common-components"),
  "CloudAccount"
);
const LicenseConfigpage = createLazyComponent(
  () => import("common-components"),
  "LicenseConfigpage"
);
const ApplicationConfiguration = createLazyComponent(
  () => import("common-components"),
  "ApplicationConfiguration"
);
const AppConfigProjects = createLazyComponent(
  () => import("common-components"),
  "AppConfigProjects"
);
const AppConfigServers = createLazyComponent(
  () => import("common-components"),
  "AppConfigServers"
);
const AppConfigUsers = createLazyComponent(
  () => import("common-components"),
  "AppConfigUsers"
);
const AppConfigAccountId = createLazyComponent(
  () => import("common-components"),
  "AppConfigAccountId"
);

const UserManagement = createLazyComponent(
  () => import("common-components"),
  "UserManagement"
);
const CloudCostConfigpage = createLazyComponent(
  () => import("common-components"),
  "CloudCostConfigpage"
);
const Schedulers = createLazyComponent(
  () => import("common-components"),
  "Schedulers"
);
const PIIDataConfiguration = createLazyComponent(
  () => import("common-components"),
  "PIIDataConfiguration"
);
const PrivilegeConfiguration = createLazyComponent(
  () => import("common-components"),
  "PrivilegeConfiguration"
);
const StatePrivilegeConfiguration = createLazyComponent(
  () => import("common-components"),
  "StatePrivilegeConfiguration"
);

const LdapConfig = createLazyComponent(
  () => import("common-components"),
  "LdapConfig"
);
const SmtpConfig = createLazyComponent(
  () => import("common-components"),
  "SmtpConfig"
);
const LicenseConfig = createLazyComponent(
  () => import("common-components"),
  "LicenseConfig"
);
const LoggingConfig = createLazyComponent(
  () => import("common-components"),
  "LoggingConfig"
);

const BambooRoles = createLazyComponent(
  () => import("common-components"),
  "BambooRoles"
);
const BitBucketRoles = createLazyComponent(
  () => import("common-components"),
  "BitBucketRoles"
);
const ConfluenceCloudRole = createLazyComponent(
  () => import("common-components"),
  "ConfluenceCloudRole"
);
const JFrogPermission = createLazyComponent(
  () => import("common-components"),
  "JFrogPermission"
);
const JenkinRoles = createLazyComponent(
  () => import("common-components"),
  "JenkinRoles"
);
const JiraCloudRoles = createLazyComponent(
  () => import("common-components"),
  "JiraCloudRoles"
);
const JiraRoles = createLazyComponent(
  () => import("common-components"),
  "JiraRoles"
);
const NexusRoles = createLazyComponent(
  () => import("common-components"),
  "NexusRoles"
);
const SonarQubeRoles = createLazyComponent(
  () => import("common-components"),
  "SonarQubeRoles"
);
//const SeveritySLAConfigurationRoles = React.lazy(() =>
//  import(
//    "../Modules/configuration/admin/tools/configurationRoles/SeveritySLAConfig.js"
//  )
//);
const SeveritySLAConfigurationRoles = createLazyComponent(
  () => import("common-components"),
  "SeveritySLAConfigurationRoles"
);

// =============== SIRAR MODULE =====================

const SirarLandings = React.lazy(() =>
  import("../Modules/SirarModule/Sirar/SirarLandings.js")
);

const SirarCisoTLLandings = React.lazy(() =>
  import("../Modules/SirarModule/SirarTLReview/CisoLandings.js")
);
const SirarCisoLandings = React.lazy(() =>
  import("../Modules/SirarModule/SirarCiso/CisoLandings.js")
);

export const authRoutes = [
  {
    name: "SignIn",
    path: "/logout",
    component: <SignIn />,
    key: "1",
  },
  {
    name: "SignIn",
    path: "/auth",
    component: <SignIn />,
    key: "2",
  },
  {
    name: "ConfigurationPage",
    path: "/ConfigurationPage",
    component: <ConfigurationPage />,
    key: "3",
  },
  {
    name: "LicenseBackend",
    path: "/LicenseBackend",
    component: <LicenseBackend />,
    key: "4",
  },
];

export const routes = [
  // Home Section
  {
    name: "Home",
    path: "home",
    component: <HomePage />,
    icon: home,
    iconNavigation: true,
    navigationDisable: false,
    key: "1",
    childNavs: [
      {
        name: "Home",
        text: "Home",
        path: "home",
        component: <HomePage />,
        navigationDisable: false,
        isNotSideBarNavigation: true,
        key: "1.1",
      },
      {
        name: "Application User Access Review",
        path: "home/userReview",
        component: <UserAccessReview />,
        isNotSideBarNavigation: true,
        key: "1.2",
      },
      {
        name: "Business Info",
        path: "home/BusinessInfoConfig",
        component: <Business />,
        isNotSideBarNavigation: true,
        key: "1.3",
      },
      {
        name: "Server",
        path: "home/:appName/DeviceConfig",
        isNotSideBarNavigation: true,
        component: <AppConfigServers />,
        key: "1.4",
      },
      {
        name: "Account IDs",
        path: "home/:appName/accountIDs",
        isNotSideBarNavigation: true,
        component: <AppConfigAccountId />,
        key: "1.5",
      },
      {
        name: "Users",
        path: "home/:appName/users",
        isNotSideBarNavigation: true,
        component: <AppConfigUsers />,
        key: "1.6",
      },
      {
        name: "Vulnerability Management",
        path: "home/VulnerabilityManagement",
        isNotSideBarNavigation: true,
        component: <Vulnerabilites />,
        key: "1.7",
      },
      {
        name: "Security Hub Findings",
        path: "home/SecurityHubFindings",
        isNotSideBarNavigation: true,
        component: <SecurityHubFindings />,
        key: "1.8",
      },
      {
        name: "TRMG Compliance",
        path: "home/trmgCompliance",
        isNotSideBarNavigation: true,
        component: <TRMGLanding />,
        key: "1.9",
      },
      {
        name: "RMiT Compliance",
        path: "home/RMiTCompliance",
        isNotSideBarNavigation: true,
        component: <RMiTLanding />,
        key: "1.10",
      },
      {
        name: "Circular 09 Compliance",
        path: "home/circular09Compliance",
        isNotSideBarNavigation: true,
        component: <ManagementC09Complaince />,
        key: "1.11",
      },
      {
        name: "CIS Benchmark",
        path: "home/CISBenchmarkCompliance",
        isNotSideBarNavigation: true,
        component: <CISBenchmarkCompliance />,
        key: "1.12",
      },
    ],
  },

  // Governance and Compliance Section
  {
    name: "IT Compliance",
    path: "ITcompliance",
    key: "2",
    icon: IT,
    iconNavigation: true,
    navigationDisable: false,
    childNavs: [
      {
        name: "IT Compliance",
        path: "ITcompliance/summary",
        component: <GNCLanding />,
        key: "2.1",
        isNotSideBarNavigation: true,
      },
      {
        name: "Vulnerability Management",
        text: "Vulnerability Management",
        path: "ITcompliance/VulnerabilityManagement",
        component: <Vulnerabilites />,
        key: "2.2",
        isNotSideBarNavigation: true,
      },
      {
        name: "SBOM",
        text: "SBOM",
        path: "ITcompliance/SBOM",
        component: <SBOMLanding isGnc={true} />,
        key: "2.3",
        isNotSideBarNavigation: true,
      },
      {
        name: "Security Hub Findings",
        text: "Security Hub Findings",
        path: "ITcompliance/SecurityHubFindings",
        component: <SecurityHubFindings />,
        key: "2.4",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISBenchmark",
        text: "CISBenchmark",
        path: "ITcompliance/CISBenchmarkCompliance",
        component: <CISBenchmarkCompliance />,
        key: "2.5",
        isNotSideBarNavigation: true,
      },
    ],
  },
  {
    name: "Assets Coverage",
    text: "Assets Coverage",
    path: "assetsCoverage",
    key: "2A",
    reactIcon: <FaServer size={20} />,
    navigationDisable: true,
    childNavs: [
      {
        name: "On-Premise",
        text: "On-Premise",
        path: "assetsCoverage/on-premise",
        component: <AssetCoverageLanding />,
        key: "2A.1",
      },
      {
        name: "Cloud",
        text: "Cloud",
        path: "assetsCoverage/cloud",
        navigationDisable: true,
        key: "2A.2",
      },
    ],
  },
  {
    name: "Regulatory Compliance",
    text: "Regulatory Compliance",
    path: "regulatoryCompliance",
    icon: Regulatory,
    iconNavigation: true,
    navigationDisable: false,
    key: "3",
    layout: true,
    component: <RegulatoryComplianceLayout />,
    childNavs: [
      {
        name: "TRMG Compliance",
        text: "TRMG Compliance",
        path: "regulatoryCompliance/trmgCompliance",
        component: <TRMGLanding />,
        key: "3.1",
        isNotSideBarNavigation: true,
      },
      {
        name: "RMiT Compliance",
        text: "RMiT Compliance",
        path: "regulatoryCompliance/RMiTCompliance",
        component: <RMiTLanding />,
        key: "3.2",
        isNotSideBarNavigation: true,
      },
      {
        name: "Circular 09 Compliance",
        text: "Circular 09 Compliance",
        path: "regulatoryCompliance/circular09Compliance",
        component: <ManagementC09Complaince />,
        key: "3.3",
        isNotSideBarNavigation: true,
      },
      {
        name: "IM8 Compliance",
        text: "IM8 Compliance",
        path: "regulatoryCompliance/IM8Compliance",
        component: <ManagementIM8Compliance />,
        key: "3.4",
        isNotSideBarNavigation: true,
      },
      {
        name: "BSP Compliance",
        text: "BSP Compliance",
        path: "regulatoryCompliance/BSPCompliance",
        component: <BSPComplianceLanding />,
        key: "3.5",
        isNotSideBarNavigation: true,
      },
    ],
  },
  {
    name: "Architecture Compliance",
    text: "Architecture Compliance",
    path: "architectureCompliance",
    key: "4",
    icon: architecture,
    childNavs: [
      {
        name: "Overview",
        text: "Overview",
        path: "architectureCompliance/Overview",
        component: <ArchitectureLanding />,
        key: "4.1",
        isNotSideBarNavigation: true,
      },
      {
        name: "AWS Configuration",
        text: "AWS Configuration",
        path: "architectureCompliance/AWSConfiguration",
        isNotSideBarNavigation: true,
        component: <ConfigurationFilter />,
        key: "4.3",
      },
    ],
  },
  {
    name: "Access Governance",
    text: "Access Governance",
    path: "accessGovernance",
    navigationDisable: true,
    customDropContainerClass: "cloudAccessGovernance",
    component: <UserReview />,
    key: "5",
    icon: accessGov,
    childNavs: [
      {
        name: "Access Governance",
        text: "Access Governance",
        path: "accessGovernance/accessGovernance",
        component: <UserReview />,
        key: "5.1",
      },
      {
        name: "Policy Insights",
        text: "Policy Insights",
        path: "accessGovernance/policyInsights",
        component: <UserGraph />,
        key: "5.2",
      },
      {
        name: "Summary PDF",
        text: "Summary PDF",
        path: "accessGovernance/accessGovernance/SummaryPDF",
        isNotSideBarNavigation: true,
        component: <SummaryPDF />,
        key: "5.3",
      },
    ],
  },
  // Cloud Insights Section
  // commanding for demo purpose
  // {
  //   name: "Cloud Insights",
  //   path: "cloudInsights",
  //   key: "6",
  //   icon: cloud,
  //   navigationDisable: true,
  // },
  // {
  //   name: "Resiliency Compliance",
  //   text: "Resiliency Compliance",
  //   path: "cloudInsights/Resilience",
  //   component: <ResilenceLanding />,
  //   key: "7",
  //   navigationDisable: true,
  //   icon: resiliency,
  // },
  {
    name: "Cloud Cost Insights",
    text: "Cloud Cost Insights",
    path: "cloudCostInsights",
    component: <CloudCostInsights />,
    key: "8",
    icon: RAMP,
    navigationDisable: false,
    childNavs: [
      {
        name: "Cost Insights",
        text: "Cost Insights",
        path: "cloudCostInsights/CostInsights",
        isNotSideBarNavigation: true,
        component: <CloudCostInsights />,
        key: "8.1"
      },
      {
        name: "Cost OverView",
        text: "Cost OverView",
        isNotSideBarNavigation: true,
        path: "cloudCostInsights/CostOverview",
        component: <CostOverview />,
        key: "8.2",
      },
    ],
  },

  {
    name: "Log Review",
    text: "Log Review",
    path: "logReview",
    component: <SirarLandings />,
    key: "10",
    icon: SirarNavIcon,
    iconNavigation: false,
    navigationDisable: true,
    childNavs: [
      {
        name: "Log Review",
        text: "Log Review",
        path: "logReview/logReview",
        component: <SirarLandings />,
        key: "10.1",
      },
      {
        name: "Log Reviewer Insights",
        text: "Log Reviewer Insights",
        path: "logReview/logReviewerInsights",
        component: <SirarCisoTLLandings />,
        key: "10.2",
      },
    ],
  },
  {
    name: "CISO Insights",
    text: "CISO Insights",
    path: "cisoInsights",
    navigationDisable: false,
    key: "11",
    icon: ciso,
    childNavs: [
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/VulnerabilityManagement",
        component: <CisoDBoardManagement />,
        key: "11.1",
        isNotSideBarNavigation: true,
      },
      {
        name: "SBOM CISO",
        text: "SBOM CISO",
        path: "cisoInsights/SBOM",
        component: <CISOSBOMLanding isGnc={true} />,
        key: "11.2",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/SecurityHubFindings",
        component: <CisoSHFLanding />,
        key: "11.3",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/trmgCompliance",
        component: <CisoTRMGLanding />,
        key: "11.4",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/RMiTCompliance",
        component: <CisoRMITLanding />,
        key: "11.5",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/BSPCompliance",
        component: <CisoBSPLanding />,
        key: "11.6",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/circular09Compliance",
        component: <CisoC09DBoardManagement />,
        key: "11.7",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/IM8Compliance",
        component: <CisoIMI8DBoardManagement />,
        key: "11.8",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Dashboard",
        text: "CISO Dashboard",
        path: "cisoInsights/CISBenchmarkCompliance",
        component: <CisoLandingCIS />,
        key: "11.10",
        isNotSideBarNavigation: true,
      },
      {
        name: "CISO Log Approver",
        text: "CISO Log Approver",
        path: "cisoInsights/logReviewer",
        component: <SirarCisoLandings />,
        isNotSideBarNavigation: true,
        key: "11.11",
      },
    ],
  },
  // Configuration Section
  {
    name: "Configuration",
    path: "configuration",
    key: "12",
    icon: configuration,
    navigationDisable: true,
    childNavs: [
      {
        name: "CMDB",
        text: "CMDB",
        navigationDisable: true,
        customDropContainerClass: "CMDB",
        key: "12.0",
        childNavs: [
          {
            name: "CMDB Overview",
            text: "CMDB Overview",
            path: "configuration/cmdb/CMDBOverview",
            component: <AppConfig />,
            key: "12.1",
          },
          {
            name: "Business Info",
            text: "Business Info",
            path: "configuration/cmdb/BusinessInfo",
            component: <Business />,
            key: "12.2",
          },
          {
            name: "Role Allocation",
            text: "Role Allocation",
            path: "configuration/cmdb/BusinessInfoConfig/roleAllocation",
            component: <RoleAllocation />,
            key: "12.3",
            isNotSideBarNavigation: true,
          },
          {
            name: "Users",
            text: "Users",
            path: "configuration/cmdb/UserInfoConfig",
            component: <User />,
            key: "12.4",
          },
          {
            name: "Devices",
            text: "Devices",
            path: "configuration/cmdb/Devices",
            component: <DevicesConfig />,
            key: "12.5",
          },
          {
            name: "Projects",
            text: "Projects",
            path: "configuration/cmdb/projects",
            component: <Projects module={"G360"} />,
            key: "12.6",
          },
          {
            name: "Cloud Accounts",
            text: "Cloud Accounts",
            path: "configuration/cmdb/cloudaccounttable/cloudaccount",
            component: <CloudAccount />,
            key: "12.7",
          },
          {
            name: "AppConfig",
            path: "configuration/cmdb",
            isNotSideBarNavigation: true,
            component: <AppConfig />,
            key: "12.8",
          },
          {
            name: "Project",
            path: "configuration/cmdb/:appname/projects",
            isNotSideBarNavigation: true,
            component: <AppConfigProjects />,
            key: "12.9"
          },
          {
            name: "Server",
            path: "configuration/cmdb/:appName/Device",
            isNotSideBarNavigation: true,
            component: <AppConfigServers />,
            key: "12.10"
          },
          {
            name: "Users",
            path: "configuration/cmdb/:appName/users",
            isNotSideBarNavigation: true,
            component: <AppConfigUsers />,
            key: "12.11"
          },
          {
            name: "Account IDs",
            path: "configuration/cmdb/:appName/CloudAccountIDs",
            isNotSideBarNavigation: true,
            component: <AppConfigAccountId />,
            key: "12.12"
          },
          {
            name: "Application Configuration",
            text: "Application Configuration",
            path: "configuration/cmdb/applicationConfiguration",
            isNotSideBarNavigation: true,
            component: <ApplicationConfiguration />,
            key: "12.13"
          },
        ],
      },
      {
        name: "Administration",
        text: "Administration",
        path: "configuration/administration/ldapConfig",
        navigationDisable: true,
        customDropContainerClass: "admin",
        component: <LdapConfig />,
        key: "13",
        childNavs: [
          {
            name: "UserManagement",
            text: "User Management",
            path: "configuration/administration/userManagement",
            component: <UserManagement />,
            key: "13.1",
          },
          {
            name: "CloudCost",
            text: " Cloud Cost",
            path: "configuration/administration/CloudCost",
            component: <CloudCostConfigpage />,
            key: "13.2",
          },
          {
            name: "Schedulers",
            text: "Schedulers",
            path: "configuration/administration/Schedulers",
            component: <Schedulers />,
            key: "13.3",
          },
          {
            name: "Tools",
            text: "Tools",
            path: "configuration/administration/tools",
            component: <Tools />,
            key: "13.4",
          },
          {
            name: "PII Data Configuration",
            text: "PII Data Configuration",
            path: "configuration/administration/PIIDataConfiguration",
            component: <PIIDataConfiguration />,
            key: "13.5",
          },
          {
            name: "IAM Policy Categorization",
            text: "IAM Policy Categorization",
            path: "configuration/administration/IAMPolicyCategorization",
            component: <PrivilegeConfiguration />,
            key: "13.6",
          },
          {
            name: "AWS State Categorization",
            text: "AWS State Categorization",
            path: "configuration/administration/AWSStateCategorization",
            component: <StatePrivilegeConfiguration />,
            key: "13.7",
          },
        ],
      },
      {
        name: "Settings",
        text: "Settings",
        path: "configuration/settings/tools",
        navigationDisable: true,
        customDropContainerClass: "settings",
        component: <Tools />,
        key: "14",
        childNavs: [
          {
            name: "LDAP Configuration",
            text: "LDAP Configuration",
            path: "configuration/settings/ldapConfig",
            component: <LdapConfig />,
            key: "14.1",
          },
          {
            name: "SmtpConfig",
            text: "SMTP Configuration",
            path: "configuration/settings/smtpConfig",
            component: <SmtpConfig />,
            key: "14.2",
          },
          {
            name: "LicenseConfig",
            text: "License Configuration",
            path: "configuration/settings/licenseConfig",
            component: <LicenseConfig />,
            key: "14.3",
          },
          {
            name: "LoggingConfig",
            text: "Logging Configuration",
            path: "configuration/settings/loggingConfig",
            component: <LoggingConfig />,
            key: "14.4",
          },
        ],
      },
      {
        name: "AuditLog",
        text: "Audit Log",
        path: "configuration/auditLog",
        component: <AuditLog />,
        key: "15",
      },
      // Tool-specific routes
      {
        name: "SonarQube Roles",
        path: "configuration/administration/tools/sonarqubeRole",
        isNotSideBarNavigation: true,
        component: <SonarQubeRoles />,
        key: "16.1",
      },
      {
        name: "Bamboo Roles",
        path: "configuration/administration/tools/bambooRole",
        isNotSideBarNavigation: true,
        component: <BambooRoles />,
        key: "16.2",
      },
      {
        name: "Bitbucket Roles",
        path: "configuration/administration/tools/bitbucketRole",
        isNotSideBarNavigation: true,
        component: <BitBucketRoles />,
        key: "16.3",
      },
      {
        name: "Jenkins Roles",
        path: "configuration/administration/tools/jenkinsRole",
        isNotSideBarNavigation: true,
        component: <JenkinRoles />,
        key: "16.4",
      },
      {
        name: "Nexus Roles",
        path: "configuration/administration/tools/nexusRole",
        isNotSideBarNavigation: true,
        component: <NexusRoles />,
        key: "16.5",
      },
      {
        name: "JFrog Permission",
        path: "configuration/administration/tools/jfrogRole",
        isNotSideBarNavigation: true,
        component: <JFrogPermission />,
        key: "16.6",
      },
      {
        name: "Jira Configuration",
        path: "configuration/administration/tools/jiraconfiguration",
        isNotSideBarNavigation: true,
        component: <JiraRoles />,
        key: "16.7",
      },
      {
        name: "Jira Cloud Roles",
        path: "configuration/administration/tools/jiracloudRole",
        isNotSideBarNavigation: true,
        component: <JiraCloudRoles />,
        key: "16.8",
      },
      {
        name: "Confluence Cloud Roles",
        path: "configuration/administration/tools/confluencecloudRole",
        isNotSideBarNavigation: true,
        component: <ConfluenceCloudRole />,
        key: "16.9",
      },
      {
        name: "License Config",
        path: "configuration/cmdb/Devices/licenseconfigpage",
        isNotSideBarNavigation: true,
        component: <LicenseConfigpage />,
        key: "16.10",
      },
      {
        name: "AWS Configuration",
        text: "AWS Configuration",
        path: "configuration/AWSConfiguration",
        isNotSideBarNavigation: true,
        component: <ConfigurationFilter />,
        key: "16.11",
      },
      {
        name: "gnc",
        text: "License Management",
        isNotSideBarNavigation: true,
        path: "/gnc/licenseManagement/licenseconfigpage",
        component: <LicenseConfigpage />,
        key: "16.12",
      },
      {
        name: "Severity SLA Configuration",
        path: "configuration/administration/tools/SeveritySLAConfigurationRole",
        isNotSideBarNavigation: true,
        component: <SeveritySLAConfigurationRoles />,
        key: "6.13",
      },
      // Dynamic route for any tool name
      {
        key: "6.dynamic",
        name: "Tool Dynamic Route",
        path: "configuration/administration/tools/:toolName",
        isNotSideBarNavigation: true,
        component: <ToolDynamicRouter />,
      },
    ],
  },
];
